import { useState } from "react";
import { FiPlus, FiTrash } from "react-icons/fi";

const emptyRow = () => ({
  Page: "",
  Type: "",
  X: "",
  Y: "",
  Value: "",
  FontSize: "",
  ImagePath: "",
  TEXTCOLOR: "#000000",
  Scale: ""
});

export default function CSVTemplateEditor({ initialRows, onPreview, onCancel }) {

  const [rows, setRows] = useState([...initialRows]);

  const updateCell = (rowIndex, key, value) => {
    const updated = [...rows];
    updated[rowIndex][key] = value;
    setRows(updated);
  };

  const addRow = () => {
    setRows([...rows, emptyRow()]);
  };

  const removeRow = (index) => {
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated.length ? updated : [emptyRow()]);
  };

  const isValid = rows.some(r => r.Page && r.Type);

  return (
    <div className="flex flex-col h-full">

      {/* Header */}
      <div className="flex justify-between items-center mb-3">

        <h2 className="text-lg font-semibold text-gray-300">
          Document Editor
        </h2>

        <button
          onClick={addRow}
          className="flex items-center gap-1 bg-gray-300 text-gray-800 hover:bg-gray-400 px-3 py-1 rounded"
        >
          <FiPlus /> Add Row
        </button>

      </div>

      {/* Table */}
      <div className="border border-gray-700 rounded overflow-auto flex-1">

        <table className="min-w-full text-sm">

          <thead className="bg-gray-800 sticky top-0">
            <tr>
              {[
                "Page","Type","X","Y","Value","FontSize",
                "ImagePath","TEXTCOLOR","Scale",""
              ].map(col => (
                <th key={col} className="px-3 py-2 border text-left">
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>

            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="hover:bg-gray-800 text-gray-800">

                {/* Page */}
                <td className="border">
                  <input
                    type="number"
                    value={row.Page}
                    onChange={e => updateCell(rowIndex,"Page",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* Type */}
                <td className="border">
                  <select
                    value={row.Type}
                    onChange={e => updateCell(rowIndex,"Type",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  >
                    <option value="">Select</option>
                    <option value="TEXT">TEXT</option>
                    <option value="IMAGE">IMAGE</option>
                  </select>
                </td>

                {/* X */}
                <td className="border">
                  <input
                    type="number"
                    value={row.X}
                    onChange={e => updateCell(rowIndex,"X",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* Y */}
                <td className="border">
                  <input
                    type="number"
                    value={row.Y}
                    onChange={e => updateCell(rowIndex,"Y",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* Value */}
                <td className="border">
                  <input
                    value={row.Value}
                    onChange={e => updateCell(rowIndex,"Value",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* FontSize */}
                <td className="border">
                  <input
                    type="number"
                    value={row.FontSize}
                    onChange={e => updateCell(rowIndex,"FontSize",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* ImagePath */}
                <td className="border">
                  <input
                    value={row.ImagePath}
                    onChange={e => updateCell(rowIndex,"ImagePath",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* TEXTCOLOR */}
                <td className="border">
                  <input
                    type="color"
                    value={row.TEXTCOLOR || "#000000"}
                    onChange={e => updateCell(rowIndex,"TEXTCOLOR",e.target.value)}
                    className="w-full h-8 outline-none"
                  />
                </td>

                {/* Scale */}
                <td className="border">
                  <input
                    type="number"
                    step="0.1"
                    value={row.Scale}
                    onChange={e => updateCell(rowIndex,"Scale",e.target.value)}
                    className="w-full px-2 py-1 outline-none"
                  />
                </td>

                {/* Delete */}
                <td className="border text-center">
                  <button
                    onClick={() => removeRow(rowIndex)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <FiTrash />
                  </button>
                </td>

              </tr>
            ))}

          </tbody>
        </table>

      </div>

      {/* Footer */}
      <div className="flex justify-end gap-3 mt-4">

        <button
          onClick={onCancel}
          className="bg-gray-600 px-4 py-2 border rounded"
        >
          Cancel
        </button>

        <button
          disabled={!isValid}
          onClick={() => onPreview(rows)}
          className={`px-4 py-2 rounded text-white ${
            isValid
              ? "bg-teal-600 hover:bg-teal-700"
              : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          Preview
        </button>

      </div>

    </div>
  );
}